// Helpers de contacto y formato para el seguimiento comercial.

/** Link de WhatsApp a partir de un teléfono argentino cargado de cualquier forma. */
export function whatsappUrl(phone?: string | null, text?: string): string | null {
  if (!phone) return null;
  let digits = phone.replace(/\D/g, '');
  if (!digits) return null;
  if (digits.startsWith('00')) digits = digits.slice(2);
  if (digits.startsWith('0')) digits = digits.slice(1);
  // Sin código de país: asumimos Argentina con el 9 de celulares.
  if (!digits.startsWith('54')) digits = `549${digits}`;
  const q = text ? `?text=${encodeURIComponent(text)}` : '';
  return `https://wa.me/${digits}${q}`;
}

export function telUrl(phone?: string | null): string | null {
  if (!phone) return null;
  const clean = phone.replace(/[^\d+]/g, '');
  return clean ? `tel:${clean}` : null;
}

export function formatMoney(n?: number | null): string {
  return `$${Math.round(Number(n || 0)).toLocaleString('es-AR')}`;
}

/** Fecha corta en horario de Argentina. */
export function formatDay(iso?: string | null): string {
  if (!iso) return '—';
  // Fecha "de día" sin zona horaria (ej. "2026-10-23T00:00:00"): se muestra tal cual, sin convertir.
  const day = /^(\d{4})-(\d{2})-(\d{2})(T00:00:00(\.0+)?Z?)?$/.exec(iso);
  if (day) return `${day[3]}/${day[2]}/${day[1].slice(2)}`;
  return new Date(iso).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: '2-digit', timeZone: 'America/Argentina/Buenos_Aires' });
}

/** Atajos para agendar el próximo llamado. */
export const CALL_SHORTCUTS: { label: string; days: number }[] = [
  { label: 'Mañana', days: 1 },
  { label: 'En 1 semana', days: 7 },
  { label: 'En 15 días', days: 15 },
  { label: 'En 1 mes', days: 30 },
  { label: 'En 3 meses', days: 90 },
];
